export const LOAN_DELIVER_FORM = '@@LoanDeliver/LOAN_DELIVER_FORM';
